// extracted by mini-css-extract-plugin
export default {"container":"Equipe_container__YRd-L","conteudo":"Equipe_conteudo__W3AJS","bt":"Equipe_bt__3JtaX"};